import { useMutation, useQuery } from '@tanstack/react-query';
import { FilesServices } from 'v2/resources/services/files';
import {
  IParamsPatchFiles,
  IPatchFilesPayload,
  IPostFilesPayload,
} from 'v2/resources/services/files/types';
import { useAppDispatch } from '../../useAppSelector';
import { setToast } from 'v2/store/toast/slice';
import { useHistory } from 'react-router-dom';

//TODO: REFACTOR IN UPDATE REACT
export const useQueryAddFiles = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();

  return useMutation({
    mutationFn: (data: IPostFilesPayload) => FilesServices.postFiles(data),
    onError: () => {
      dispatch(
        setToast({
          message: 'Error ao enviar arquivos',
          severity: 'error',
        })
      );
    },
    onSuccess: () => {
      dispatch(
        setToast({
          message: 'Arquivos enviados com sucesso',
          severity: 'success',
        })
      );
      navigate.goBack();
    },
  });
};

export const useQueryPatchFiles = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();

  return useMutation({
    mutationFn: (data: IParamsPatchFiles) => FilesServices.patchFiles(data),
    onError: () => {
      dispatch(
        setToast({
          message: 'Error ao editar arquivos',
          severity: 'error',
        })
      );
    },
    onSuccess: () => {
      dispatch(
        setToast({
          message: 'Arquivos editados com sucesso',
          severity: 'success',
        })
      );
      navigate.goBack();
    },
  });
};

export const useQueryDeleteFiles = () => {
  const dispatch = useAppDispatch();

  return useMutation({
    mutationFn: (id: string) => FilesServices.deleteFiles(id),
    onError: () => {
      dispatch(
        setToast({
          message: 'Error ao deletar arquivos',
          severity: 'error',
        })
      );
    },
    onSuccess: () => {
      dispatch(
        setToast({
          message: 'Arquivo deleteado com sucesso',
          severity: 'success',
        })
      );
    },
  });
};

export const useQueryGetFiles = () => {
  return useQuery({
    queryKey: ['getFiles'],
    queryFn: () => FilesServices.getFiles(),

    enabled: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
};
